// extracted by mini-css-extract-plugin
export var banner = "style-module--banner--2AzSt";
export var image = "style-module--image--XlcFR";
export var title = "style-module--title--UQVdY";
export var content = "style-module--content--3vuvW";
export var item = "style-module--item--3O02h";
export var itemImage = "style-module--itemImage--2J7fN";
export var itemTitle = "style-module--itemTitle--eYQdw";
export var itemDescr = "style-module--itemDescr--2iyhx";